import docsIcon from "../assets/images/docs.png";
import faqIcon from "../assets/images/faq.png";
import judgeIcon from "../assets/images/judge.png";
import qnaIcon from "../assets/images/qna.png";
import uploadIcon from "../assets/images/upload.png";
import announcementIcon from "../assets/images/announcement.png";
import progressIcon from "../assets/images/progress.png";
import reportIcon from "../assets/images/report.png";
import sportIcon from "../assets/images/sports.png";
import instructorIcon from "../assets/images/instructor.png";
import scoreIcon from "../assets/images/score.png";

const staffMenus = [
  {
    tabName: "진행상황",
    path: "/staff/progress",
    icon: progressIcon,
  },
  {
    tabName: "공지사항",
    path: "/staff/announcement",
    icon: announcementIcon,
  },
  {
    tabName: "자료실",
    path: "/staff/material",
    icon: docsIcon,
  },
  {
    tabName: "Q&A",
    path: "/staff/qna",
    icon: qnaIcon,
  },
  {
    tabName: "문서 업로드",
    path: "/staff/docs",
    icon: judgeIcon,
  },
  {
    tabName: "현장실습 목록",
    path: "/staff/training",
    icon: sportIcon,
  },
  {
    tabName: "FAQ",
    path: "/staff/faq",
    icon: faqIcon,
  },
  {
    tabName: "지도자 관리",
    path: "/staff/instructor",
    icon: instructorIcon,
  },
  {
    tabName: "점수입력",
    path: "/staff/score",
    icon: scoreIcon,
  },
];

const studentMenus = [
  {
    tabName: "진행상황",
    path: "/student/progress",
    icon: progressIcon,
  },
  {
    tabName: "공지사항",
    path: "/student/announcement",
    icon: announcementIcon,
  },
  {
    tabName: "자료실",
    path: "/student/material",
    icon: docsIcon,
  },
  {
    tabName: "Q&A",
    path: "/student/qna",
    icon: qnaIcon,
  },
  {
    tabName: "현장실습 정보입력",
    path: "/student/report",
    icon: reportIcon,
  },
  {
    tabName: "문서 업로드",
    path: "/student/docs",
    icon: uploadIcon,
  },
  {
    tabName: "실습신청",
    path: "/student/training",
    icon: sportIcon,
  },
  {
    tabName: "FAQ",
    path: "/student/faq",
    icon: faqIcon,
  },
];

export const menus = {
  staff: staffMenus,
  student: studentMenus,
  instructor: [],
};
